export var FlowPricingMode;
(function (FlowPricingMode) {
    FlowPricingMode["Block"] = "block";
    FlowPricingMode["Task"] = "task";
})(FlowPricingMode || (FlowPricingMode = {}));
//# sourceMappingURL=pricingMode.js.map